export enum LeftMenuBackendTabs {
  SERVER = 'server',
  AUTH = 'auth',
  DATABASE = 'database',
  Entities = 'entities',
}
